import React, { useMemo, useState } from 'react'
import { ModalContentWrapper, ModalFooterWarpper, ModalInputBoxWrapper, ModalLabelWrapper } from '../common/ModalStyled'
import InputBoxOnChangeValid from '../myInfo/InputBoxOnChangeValid'
import InputBoxOnChangePWCheck from '../myInfo/InputBoxOnChangePWCheck'
import { putUserPassword } from 'src/api/User'
import { ActionButton, NextButton } from '../common/CommonStyled'
import { useModalStore } from 'src/stores/ModalStore'
import { toast } from 'react-toastify'

const AdChangePWModalContent = () => {
    const [currentPW,setCurrentPW] = useState('')
    const [newPW,setNewPW] = useState('')
    const modalSetField = useModalStore((state)=>state.setField)

    //발리데이션
    const [cond0,setCond0] = useState(false)
    const [cond1,setCond1] = useState(false)
    const [cond2,setCond2] = useState(false)
    const isValid = useMemo(()=>{
        if (!currentPW || !newPW) return false
        return cond0 && cond1 && cond2
    },[cond0,cond1,cond2])

    // 보완필요 >> 성공/실패팝업창 없음
    const handleChangePW = async(currentPw:string, newPw:string)=>{
        const response = await putUserPassword(currentPw,newPw)
        if(response === 400){
          toast.error('입력하신 비밀번호와 현재 비밀번호가 다릅니다.',{autoClose:2000})
        }
        else{
          toast.success('비밀번호가 성공적으로 변경되었습니다.',{autoClose:2000})
        }
    }

      const handleCurrentPW = (e:React.ChangeEvent<HTMLInputElement>)=>{
        setCurrentPW(e.target.value)
      }
    
      const handleNewPW = (e:React.ChangeEvent<HTMLInputElement>)=>{
        setNewPW(e.target.value)
      }

  return (
    <ModalContentWrapper style={{marginBottom:'16px'}}>
        <ModalInputBoxWrapper>
          <ModalLabelWrapper>기존 비밀번호</ModalLabelWrapper>
        <InputBoxOnChangeValid
                type='password'
                placeholder="기존 비밀번호"
                value={currentPW}
                onChange={handleCurrentPW}
                setCond={setCond0}
                lengthRegex={/^.{8,20}$/}
                lengthSpan='비밀번호 길이는 8~20자만 가능합니다.'
                //eslint-disable-next-line
                regex0={/^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?/~\-]).+$/}
                regex0Span='영문, 숫자, 특수문자를 모두 포함해야 합니다.'
            />
        </ModalInputBoxWrapper>
        <ModalInputBoxWrapper>
          <ModalLabelWrapper>변경할 비밀번호</ModalLabelWrapper>
          <InputBoxOnChangeValid
                type='password'
                placeholder="비밀번호(8~32자, 영문 대/소문자+숫자+특수문자)"
                value={newPW}
                onChange={handleNewPW}
                setCond={setCond1}
                lengthRegex={/^.{8,20}$/}
                lengthSpan='비밀번호 길이는 8~20자만 가능합니다.'
                //eslint-disable-next-line
                regex0={/^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?/~\-]).+$/}
                regex0Span='영문, 숫자, 특수문자를 모두 포함해야 합니다.'
            />
        </ModalInputBoxWrapper>
        <ModalInputBoxWrapper>
          <ModalLabelWrapper>변경할 비밀번호 확인</ModalLabelWrapper>
          <InputBoxOnChangePWCheck
                type='password'
                placeholder="변경할 비밀번호 확인"
                value={newPW}
                setCond={setCond2}
            />
        </ModalInputBoxWrapper>
        <ModalFooterWarpper>
            <ActionButton style={{width:'100%', height:'50px'}} onClick={()=>modalSetField('open',false)}>취소</ActionButton>
            <NextButton disabled={!isValid} onClick={()=>handleChangePW(currentPW,newPW)}>비밀번호 변경</NextButton>
        </ModalFooterWarpper>
      </ModalContentWrapper>
  )
}

export default AdChangePWModalContent